const TeacherProfileTrustBar = () => {
    return (
        <div className="trust-bar">
            <div className="container">
                <h4>Give with confidence</h4>
                <h2 className="trust-bar-headline thick">Trusted by millions of teachers and donors</h2>
                <p className="trust-bar-description subheader">
                    We&apos;re a teacher-founded nonprofit with top ratings from Charity Navigator, CharityWatch, and Guidestar.
                </p>
                <a className="trust-bar-link" href={`${baseURL}about`}>
                    Learn more about DonorsChoose
                </a>
            </div>
        </div>
    );
};

export default TeacherProfileTrustBar;
